import {SortSettings} from '@features/search/interfaces';

export function getDefaultSortSettings(): SortSettings {
    return {
        sortArticles: false
    }
}
